import React, { Component } from 'react';

import { DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Box, FormControl, FormHelperText, TextField } from '@mui/material';
import 'date-fns';


class DatePickerCmp extends Component {

    render(){
        const { label, value, minDate, maxDate, error, required, noPadding, disabled } = this.props;
        return (
            <Box p={noPadding ? 0 : 1}>
                <FormControl variant="outlined" error={!!error} style={{ width: "100%" }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                            invalidDateMessage="Date Invalide"
                            minDate={minDate}
                            maxDate={maxDate}
                            id="date-picker-dialog"
                            label={`${label}${required ? " *": ""}`}
                            value={value}
                            onChange={this.props.onChange || this.props.handleChange}
                            inputFormat="dd/MM/yyyy"
                            InputLabelProps={{ shrink: true }}
                            autoOk={true}
                            PopperProps={{
                                style: { zIndex: 13002 },
                                sx: { zIndex: 13002 }
                            }}
                            renderInput={(params) => (
                                <TextField 
                                    {...params} 
                                    variant="outlined"
                                    error={!!error} 
                                    disabled={disabled}
                                    fullWidth
                                />
                            )}
                        />
                    </LocalizationProvider>
                    <FormHelperText>{error}</FormHelperText>
                </FormControl>
            </Box>
        )
    }  
}

export default DatePickerCmp;